<template>
    <div v-if="!isExport">
        <b-row>
            <b-col md="9">
                <div class="pass-rate-chart-container">
                    <chart-loader
                        :loading="loading.passRates"
                    ></chart-loader>
                    <charts-pass-rate
                        :chart-data="chartdata"
                        :options="chartOptions"
                    />
                </div>
            </b-col>
            <b-col md="3">
                <b-form class="chart-filter mb-3 border shadow-sm rounded">
                    <b-form-group label="Show pass rate by">
                        <b-form-select
                            class="mb-2 mr-sm-2 mb-sm-0"
                            :value="1"
                            v-model="selectedGroup"
                            :options="selectionGroups"
                            @change="change"
                        >
                            <template v-slot:first>
                                <option :value="null">Show all</option>
                            </template>
                        </b-form-select>
                    </b-form-group>
                    <b-form-group class="mb-0">
                        <b-form-checkbox-group
                            v-model="selected[selectedGroup]"
                            stacked
                            :options="options"
                        ></b-form-checkbox-group>
                    </b-form-group>
                </b-form>
            </b-col>
        </b-row>
    </div>
    <div v-else>
        <h4 class="mt-3">Pass Rates</h4>
        <b-card class="card-chart" :class="{ 'no-shadow': isExport }">
            <b-row>
                <b-col md="12">
                    <div class="pass-rate-chart-container">
                        <chart-loader
                            :loading="loading.passRates"
                        ></chart-loader>
                        <charts-pass-rate
                            :height="210"
                            :chart-data="chartdata"
                            :options="chartOptions"
                        />
                    </div>
                </b-col>
            </b-row>
        </b-card>
    </div>
</template>

<script>
import { mapActions, mapState, mapGetters } from "vuex";
import ChartLoader from "../Charts/ChartLoader";

export default {
  name: "PassRateContainer",
  props: {
    range: String,
    isExport: Boolean
  },
  components: {
    ChartLoader
  },
  data() {
    return {
      selectionGroups: {
        materials: "Material",
        collections: "Collection",
        manufacturers: "Manufacturer"
      },
      selectedGroup: null,
      selected: {
        materials: [],
        manufacturers: [],
        collections: []
      },
      url: window.location.href,
      chartOptions: {
        maintainAspectRatio: false,
        responsive: true,
        legend: {
          display: false
        },
        scales: {
          yAxes: [
            {
              ticks: {
                callback: function(tick) {
                  return tick.toString() + "%";
                }
              }
            }
          ]
        },
        tooltips: {
          custom: function(tooltip) {
            // Disable displaying the color box
            if (!tooltip) return;
            tooltip.displayColors = false;
          },
          callbacks: {
            // Show percentage in tooltip
            label: function(tooltipItem, data) {
              let label = data.datasets[tooltipItem.datasetIndex].label;
              return `${label} ${tooltipItem.value} %`;
            }
          }
        }
      }
    };
  },
  computed: {
    ...mapGetters({
      manufacturers: "analytics/getManufacturersForFormSelect",
      materials: "analytics/getMaterialsForFormSelect",
      chartdata: "analytics/getPassRateChartData"
    }),
    ...mapState("analytics", {
      start_date: state => state.start_date,
      end_date: state => state.end_date,
      unit: state => state.unit,
      loading: state => state.loading,
      rawCollections: state => state.collections,
      client_id: state => state.clientIdFilter
    }),
    options() {
      return this[this.selectedGroup];
    },
    collections() {
      return this.rawCollections.map(c => {
        let text = this.client_id
          ? c.name
          : c.name + " (" + c.client.name + ")";
        return {
          text: text,
          value: c.id
        };
      });
    }
  },
  watch: {
    selected: {
      handler(v) {
        this.change();
      },
      deep: true
    }
  },
  mounted() {
    if (!this.isExport) {
      this.getManufacturers({
        start_date: this.start_date,
        end_date: this.end_date,
        unit: this.unit
      });
      this.getCollections({
        start_date: this.start_date,
        end_date: this.end_date,
        unit: this.unit
      });
      this.getMaterials({
        start_date: this.start_date,
        end_date: this.end_date,
        unit: this.unit
      });
      this.fetchData();

      this.$root.$on("passRate", () => {
        this.reRender();
      });
    }
  },
  methods: {
    ...mapActions({
      getManufacturers: "analytics/getManufacturers",
      getCollections: "analytics/getCollections",
      getMaterials: "analytics/getMaterials",
      getPassRates: "analytics/getPassRates"
    }),
    change() {
      this.fetchData({
        type: this.selectedGroup,
        ids: this.selected[this.selectedGroup]
      });
    },
    fetchData(filters) {
      this.getPassRates({
        ...filters,
        start_date: this.start_date,
        end_date: this.end_date,
        unit: this.unit
      });
    },
    reRender() {
      this.getManufacturers({
        start_date: this.start_date,
        end_date: this.end_date,
        unit: this.unit
      });
      this.getCollections({
        start_date: this.start_date,
        end_date: this.end_date,
        unit: this.unit
      });
      this.getMaterials({
        start_date: this.start_date,
        end_date: this.end_date,
        unit: this.unit
      });
      this.fetchData();

      this.$root.$emit("passRateChart");
    }
  }
};
</script>

<style scoped>
.no-shadow {
  box-shadow: none !important;
}
</style>
